import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import {
  Center,
  Spinner,
  Alert,
  AlertIcon,
  AlertDescription,
  useColorModeValue,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import { apiGetBinderReportData } from 'api';
import type {
  APIBinderReportData,
  APIHomeBinderData,
  APIBinderData,
  APIHomeBinderReportData,
} from 'types/api.types';
import AutoBinderReport from './AutoBinderReport';
import HomeBinderReport from '../home_binder_report/HomeBinderReport';
import { RUNNER_MC_HOME } from 'variables/constants';

const BinderReportView = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const bgColor = useColorModeValue('white', 'navy.800');

  // Fetch the policy data to determine type
  const {
    data: binderReportData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['binder-report', uuid],
    queryFn: () => apiGetBinderReportData(uuid || ''),
    enabled: !!uuid,
    retry: false,
  }) as {
    data: APIBinderReportData | APIHomeBinderReportData;
    isLoading: boolean;
    error: any;
  };

  if (isLoading) {
    return (
      <Center py={10}>
        <Spinner size="xl" color="brand.500" />
      </Center>
    );
  }

  if (error) {
    return (
      <Card bg={bgColor} p={8}>
        <Alert status="error">
          <AlertIcon />
          <AlertDescription>
            Failed to load home binder report. Please try again.
          </AlertDescription>
        </Alert>
      </Card>
    );
  }

  const isHomePolicy = binderReportData?.runner === RUNNER_MC_HOME;

  if (isHomePolicy) {
    return (
      <HomeBinderReport
        data={binderReportData.binder_data as APIHomeBinderData | null}
      />
    );
  }

  return (
    <AutoBinderReport
      data={binderReportData?.binder_data as APIBinderData | null}
    />
  );
};

export default BinderReportView;
